import { Form } from "react-bootstrap";
import type { IndexQuestion, LookupTable, LookupValueType } from "./types";
import "./style.css";

export interface LookupGridProps {
  index1Question?: IndexQuestion;
  index2Question?: IndexQuestion;
  valueType: LookupValueType;
  value: LookupTable;
  onChange: (next: LookupTable) => void;
}

export const LookupGrid = ({
  index1Question,
  index2Question,
  valueType,
  value,
  onChange,
}: LookupGridProps): JSX.Element => {
  const inputType = valueType === "number" ? "number" : "text";

  if (!index1Question) {
    return (
      <div className="text-muted p-2">
        Select Index 1 to build the lookup grid.
      </div>
    );
  }

  if (!index2Question) {
    const set = (optValue: string, v: string) =>
      onChange({ ...value, [optValue]: v });
    return (
      <table className="table table-sm lookup-grid mt-3">
        <thead>
          <tr>
            <th>Selected Value</th>
            <th>Associated Value</th>
          </tr>
        </thead>
        <tbody>
          {index1Question.options.map((opt) => (
            <tr key={opt.value}>
              <td>{opt.key}</td>
              <td>
                <Form.Control
                  type={inputType}
                  aria-label={`lookup ${opt.value}`}
                  value={(value[opt.value] as string) ?? ""}
                  onChange={(e) => set(opt.value, e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  const setCell = (rowValue: string, colValue: string, v: string) => {
    const row = (value[rowValue] as Record<string, string>) ?? {};
    onChange({ ...value, [rowValue]: { ...row, [colValue]: v } });
  };
  return (
    <div className="lookup-grid-scroll mt-3">
      <table className="table table-sm lookup-grid">
        <thead>
          <tr>
            <th />
            {index2Question.options.map((c) => (
              <th key={c.value}>{c.key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {index1Question.options.map((r) => {
            const row = (value[r.value] as Record<string, string>) ?? {};
            return (
              <tr key={r.value}>
                <th>{r.key}</th>
                {index2Question.options.map((c) => (
                  <td key={c.value}>
                    <Form.Control
                      type={inputType}
                      aria-label={`lookup ${r.value} ${c.value}`}
                      value={row[c.value] ?? ""}
                      onChange={(e) =>
                        setCell(r.value, c.value, e.target.value)
                      }
                    />
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LookupGrid;
